module.exports = __webpack_public_path__ + "img/3-mov.b381021e.webp";